/**
 * Promotes the server-rendered user state into `user.connectedUser`, which is the shape the
 * user slice selectors expect.
 */
export const initConnectedUser = (initState: any = {}) => {
    if (initState.user) {
        Object.assign(initState.user, {
            initialize: true,
            connectedUser: { ...initState.user },
        });
    }

    if (initState.customer) {
        const { customer } = initState;

        Object.assign(initState, {
            feed: {
                ALL: customer.feedAll,
                PUBLIC: customer.feedPublic,
                entities: {},
            },
        });
    }

    return initState;
};
